// Secciones del pitch profesional ICETEX (5 min)
// Los section_title deben coincidir con los de PITCH_5MIN_QUESTIONS del backend
export const PITCH_SECTIONS = [
  { id: 'audiencia_contexto', title: 'Audiencia y contexto' },
  { id: 'problema', title: 'Problema / Contexto ICETEX' },
  { id: 'solucion', title: 'Solución / Iniciativa' },
  { id: 'impacto_evidencia', title: 'Impacto y evidencia' },
  { id: 'equipo_credibilidad', title: 'Equipo y credibilidad' },
  { id: 'ask_cierre', title: 'El Ask y cierre' },
];

// Bloques con respuesta predefinida (sin consumo de IA).
// Deben coincidir con _PREDEFINED_PITCH_BLOCKS del backend pitch_service.py
export const PREDEFINED_PITCH_SECTIONS = new Set([
  'Audiencia y contexto',
  'Impacto y evidencia',
  'Equipo y credibilidad',
  'El Ask y cierre',
]);
